import { render, staticRenderFns } from "./SubDealerView.vue?vue&type=template&id=2f405b58&scoped=true&lang=html&"
import script from "./SubDealerView.vue?vue&type=script&lang=js&"
export * from "./SubDealerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f405b58",
  null
  
)

export default component.exports